import React, {useEffect} from 'react'
import UserCard from '../User/UserCard/UserCard';
import {Box} from '@mui/material';
import {populatePublicUsers} from '../../data/User/userHelper';
import {useDispatch, useSelector} from "react-redux";

export default function FindUsers() {
    const dispatcher = useDispatch();
    const users = useSelector(state=> state.user.users);
    useEffect(() => {
        populatePublicUsers(dispatcher)
    }, [dispatcher])

    return (
        <Box display="flex" flexWrap="wrap"
             justifyContent='space-around'>
            {users.map((user) => {
                return (<UserCard key={user.id} user={user}/>)
            })}
        </Box>
    )
}
